import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { CompassLogo } from "@atlaskit/logo";

import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import { BlueWaveTemplate } from "@/components/signup/layouts/blue-wave-template";
import {
    useStandardIntent,
    usePremiumIntent
} from "@/components/user-context/helpers/cohorts";
import { Picture } from "@/components/wpl/image/src/image";

import { NoCreditCardRequired } from "../components/no-credit-card-required";

export const LoggedOut = () => {
    const { formatMessage } = useIntl();
    const standard = useStandardIntent();
    const premium = usePremiumIntent();
    const productEditionText = premium
        ? formatMessage({
              id: "WacSignupHeader.cloudPremium",
              defaultMessage: "Cloud Premium"
          })
        : standard
        ? formatMessage({
              id: "WacSignupHeader.cloudStandard",
              defaultMessage: "Cloud Standard"
          })
        : formatMessage({
              id: "WacSignupHeader.cloudFree",
              defaultMessage: "Cloud Free"
          });
    return (
        <BlueWaveTemplate
            productEditionText={productEditionText}
            illustration={
                <Picture
                    image={{
                        src: "https://atlassian.com/dam/jcr:ddb40094-3568-4eee-84fb-adfd5b20ca96/Compass_SignUpPage_Illo%20(5).svg",
                        alt: ""
                    }}
                />
            }
            productLogos={[
                <CompassLogo key="compass" size="xlarge" appearance="inverse" />
            ]}
            tagline={formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextCompass",
                defaultMessage:
                    "Create a better developer experience with Compass"
            })}
            valueProps={formatMessage(
                {
                    id: "WacSignupForm.signupOfferingIncludesFeaturesFreeCompass",
                    defaultMessage:
                        "Reduce context switching with a comprehensive software catalog{newline}Keep your architecture reliable, performant, and secure with scorecards and metrics{newline}Connect your existing tools and data and create custom integrations for a bespoke developer experience"
                },
                { newline: "{newline}" }
            )
                .replace(/\n/g, "{newline}") // replace all newlines with a placeholder so we can split on it
                .replace(/&rsquo;/g, "’") // replace the &rsquo; with an actual apostrophe
                .split("{newline}")}
            showAtlassianLogo={true}
        >
            <h2 css={headingCss}>
                {formatMessage({
                    id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandard",
                    defaultMessage: "Start now"
                })}
            </h2>
            <AccountCreation Login={<NoCreditCardRequired />} />
        </BlueWaveTemplate>
    );
};

const headingCss = css({
    fontSize: "2rem",
    fontWeight: 500,
    margin: 0,
    textAlign: "center"
});
